const CallForHelp = () => {
  return (
    <div className='mt-5 flex justify-center text-sm uppercase text-[var(--bluon--default--blue-3)]'>
      Call for Help: (657) 439-7658
    </div>
  );
};

export default CallForHelp;
